// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dleP1","fullView":"styles_fullView__1kVVz"};